import { TooltipGeneral } from ".";
import { TooltipGeneralProps, TooltipOptionalProps } from "./types";

export const TooltipOptional = ({
    children,
    isHidden,
    ...props
}: TooltipOptionalProps & TooltipGeneralProps) => {
    if (!isHidden) {
        return <TooltipGeneral {...props}>{children}</TooltipGeneral>;
    }
    return children;
};
